<template>
    <div class="container">
        <back-button location="/technologies"></back-button>
        <h1 class="title">Analysis</h1>
        <div class="logo swing-animation">
            <img src="../../assets/images/Analysis.svg"/>
        </div>
        <div class="content">
            <div class="mobile-version-chart">
                <div class="chart-group">
                    <p class="chart-sub-title">How analysts document requirements for solutions</p>
                    <apex-charts type="bar" :options="serveOptions" :series="serveSeries" class="chart"
                                 height="300px"></apex-charts>
                </div>
                <p class="fun-fact">82% of analysts read code as part of the analysis process</p>
            </div>
            <div class="mobile-module-chart">
                <p class="fun-fact">56% of analysts are responsible for cultivating an agile culture</p>
                <div class="chart-group">
                    <p class="chart-sub-title">How often analysts were involved in sizing and future planning</p>
                    <apex-charts type="bar" :options="moduleOptions" :series="moduleSeries" class="chart"></apex-charts>
                </div>
            </div>
            <div class="mobile-serve-chart">
                <div class="chart-group">
                    <p class="chart-sub-title">Tools most used by analysts for creating diagrams</p>
                    <apex-charts type="donut" :options="availabilityOptions" :series="availabilitySeries"
                                 class="chart"></apex-charts>
                </div>
                <p class="fun-fact">72% of analysts are involved in defining flight plans for projects</p>
            </div>
            <div class="mobile-build-chart">
                <p class="fun-fact">40% of analysts are responsible for wireframing and prototyping</p>
                <div class="chart-group">
                    <p class="chart-sub-title">People analysts work with the most</p>
                    <apex-charts type="bar" :options="platformOptions" :series="platformSeries"
                                 height="400px" class="chart"></apex-charts>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import VueApexCharts from "vue-apexcharts/src";
    import BackButton from "../../widgets/BackButton";

    export default {
        components: {
            'apex-charts': VueApexCharts,
            BackButton
        },
        data: function () {
            return {
                platformOptions: {
                    chart: {
                        toolbar: {
                            show: false
                        }
                    },
                    colors: ['#003974', '#8EC63F', '#008AD0', '#B51E8E', '#D8181F', '#F387B7', '#009EA5', '#00994C', '#482F92', '#F7941D'],
                    labels: ['Developers', 'Business', 'Product Owners', 'UX Designers', 'End Users', 'Quality Assurance'],
                    plotOptions: {
                        bar: {
                            columnWidth: '45%',
                            distributed: true,
                            horizontal: true
                        }
                    },
                    dataLabels: {
                        enabled: false,
                    },
                    yaxis: {
                        categories: ['Developers', 'Business', 'Product Owners', 'UX Designers', 'End Users', 'Quality Assurance'],
                        labels: {
                            style: {
                                colors: ['#fff', '#fff', '#fff', '#fff', '#fff', '#fff', '#fff', '#fff', '#fff'],
                                fontSize: '14px'
                            }
                        }
                    },
                    xaxis: {
                        labels: {
                            style: {
                                colors: '#FFF',
                            },
                        }
                    },
                    tooltip: {
                        theme: 'dark',
                        y: {
                            formatter: (value) => `${value}%`
                        },
                        marker: {
                            show: true
                        }
                    },
                },
                platformSeries: [{
                    name: 'Involvement',
                    data: [83.3, 71.1, 62.8, 25.6, 24.4, 21.8]
                }],
                availabilityOptions: {
                    chart: {
                        toolbar: {
                            show: false
                        }
                    },
                    legend: {
                        labels: {
                            color: '#FFF'
                        },
                        position: 'bottom',
                    },
                    colors: ['#B51E8E', '#009EA5', '#F7941D', '#008AD0', '#00994C'],
                    labels: ['Draw.io', 'MS Visio', 'Enterprise Architect', 'MS PowerPoint', 'Other'],
                    tooltip: {
                        enabled: true,
                        y: {
                            formatter: (value) => `${value}%`
                        }
                    },
                    stroke: {
                        width: 0
                    },
                    fill: {
                        patern: {
                            width: 500
                        }
                    },
                    plotOptions: {
                        pie: {
                            donut: {
                                size: '50%',
                            },
                        }
                    },
                    dataLabels: {
                        formatter: (val) => {
                            if (val < 7) {
                                return '';
                            }

                            return `${Math.round(val)}%`;
                        }
                    },
                },
                availabilitySeries: [26.9, 20.5, 9, 9, 34.6],
                moduleOptions: {
                    chart: {
                        stacked: true,
                        stackType: '100%',
                        toolbar: {
                            show: false
                        }
                    },
                    dataLabels: {
                        formatter: (val) => {
                            if (val < 7) {
                                return '';
                            }

                            return `${Math.round(val)}%`;
                        }
                    },
                    colors: ['#B51E8E', '#F7941D', '#008AD0', '#F7941D', '#00994C'],
                    plotOptions: {
                        bar: {
                            horizontal: true,
                        }
                    },
                    legend: {
                        position: 'top',
                        labels: {
                            color: '#FFF'
                        }
                    },
                    yaxis: {
                        labels: {
                            style: {
                                color: '#FFF',
                            },
                            show: false,
                        },
                        
                    },
                    xaxis: {
                        labels: {
                            style: {
                                colors: '#FFF',
                            },
                        },
                        categories: ['Involvement in planning'],
                    },
                    tooltip: {
                        theme: 'dark',
                        y: {
                            formatter: (value) => `${value}%`
                        }
                    },
                },
                moduleSeries: [{
                    name: 'Always',
                    data: [69.2]
                }, {
                    name: 'Sometimes',
                    data: [24.4]
                }, {
                    name: 'Never',
                    data: [6.4]
                }],
                serveOptions: {
                    chart: {
                        toolbar: {
                            show: false
                        }
                    },
                    colors: ['#B51E8E', '#009EA5', '#F7941D', '#008AD0', '#00994C'],
                    labels: ['User stories', 'Tracking tool', 'Wireframes', 'FRS', 'BRD'],
                    plotOptions: {
                        bar: {
                            columnWidth: '45%',
                            distributed: true
                        }
                    },
                    dataLabels: {
                        enabled: false,
                    },
                    yaxis: {
                        labels: {
                            style: {
                                color: '#FFF',
                            },
                        }
                    },
                    xaxis: {
                        categories: ['User stories', 'Tracking tool', 'Wireframes', 'FRS', 'BRD'],
                        labels: {
                            style: {
                                colors: '#fff',
                                fontSize: '14px'
                            }
                        }
                    },
                    tooltip: {
                        theme: 'dark',
                        y: {
                            formatter: (value) => `${value}%`
                        },
                        marker: {
                            show: true
                        }
                    },
                },
                serveSeries: [{
                    name: 'Amount',
                    data: [65.4, 51.3, 37.2, 34.6, 30.8]
                }],
            }
        },
        methods: {
            track () {
                this.$ga.page('/2018/technology/analysis') // This is for Google Analytics tracking
            }
        }
    }
</script>

<style lang="scss" scoped>
    .container {
        display: grid;
        grid-template-columns: 1fr 600px 1fr;
        grid-template-rows: auto 1fr;
        grid-template-areas: 'back title   logo' 'content content content';
        color: white;
        text-align: center;
        background-size: cover;
        background-position: center;
        padding-bottom: 48px;

        @media only screen and (max-width: $screen-sm-max) {
            grid-template-columns: 1fr 2fr 1fr;
        }

        .logo {
            grid-area: logo;
            height: 160px;
            width: 160px;
            align-self: start;
            justify-self: end;
            background: $green;
            border-bottom-left-radius: 100%;
            display: grid;

            @media only screen and (max-width: $screen-xs-max) {
                display: none;
            }

            img {
                width: 50%;
                height: 50%;
                align-self: start;
                justify-self: end;
                margin: 20px;
            }
        }

        .title {
            grid-area: title;
            align-self: center;
            justify-self: center;
            align-content: center;
            justify-content: center;
            margin: 24px;
            display: grid;
        }

        .content {
            grid-area: content;
            display: grid;
            grid-template-areas: '. version module .' '. serve build .';
            grid-template-columns: 1fr 1fr 1fr 1fr;
            grid-template-rows: auto auto;

            @media only screen and (max-width: $screen-sm-max) {
                grid-template-areas: '. version .' '. module .' '. serve .' '. build .';
                grid-template-columns: 1fr 2fr 1fr;
            }

            .fun-fact {
                align-self: center;
                justify-self: center;
                margin: 24px;
            }

            .chart {
                width: 360px;
                align-self: center;
                justify-self: center;

                @media only screen and (max-width: $screen-xs-max) {
                    width: 250px;
                }
            }

            .chart-group {
                border-left: 2px solid $entelect-orange;
                padding-left: 24px;
                display: grid;
            }

            .chart-title {
                align-self: start;
                justify-self: start;
            }

            .chart-sub-title {
                align-self: start;
                justify-self: start;
                text-align: left;
                margin-bottom: 24px;
            }

            .mobile-version-chart {
                grid-area: version;
                display: grid;

                .chart-sub-title {
                    width: 250px;
                }
            }

            .mobile-serve-chart {
                grid-area: serve;
                display: grid;
                padding-top: 24px;

                .chart-sub-title {
                    width: 250px;
                }
            }

            .mobile-module-chart {
                grid-area: module;
                display: grid;

                .chart-sub-title {
                    width: 250px;
                }
            }

            .mobile-build-chart {
                grid-area: build;
                display: grid;

                .chart-sub-title {
                    width: 250px;
                    margin: 0;
                }
            }
        }
    }
</style>
